import { render } from "storyblok-rich-text-react-renderer"
import SbEditable from "@mkt/ui/components/common/SbEditable"
import { Accordion, Text } from "iq-blueberry"
import { Helmet } from "react-helmet"
import * as S from "./styles.js"

const extractTextFromRichText = (richText) => {
  if (!richText || !richText.content) return ""
  return richText.content
    .map((node) => {
      if (node.type === "paragraph" && node.content) {
        return node.content.map((child) => child.text).join("")
      }
      return ""
    })
    .join("\n")
}

const generateFaqSchema = (content) => {
  if (!content || !content.body) return null

  const faqItems = content.body.map((childBlok) => ({
    "@type": "Question",
    name: childBlok.title,
    acceptedAnswer: {
      "@type": "Answer",
      text: extractTextFromRichText(childBlok.desc),
    },
  }))

  const faqPageSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems,
  }

  return faqPageSchema
}

const FAQ = ({ content }) => {
  const faqSchema = generateFaqSchema(content)

  return (
    <div css={S.faq} id="faq">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <SbEditable content={content}>
        <div css={S.faqContainer}>
          <Text css={S.faqTitle} as="h2" variant="heading-three">
            {render(content.title)}
          </Text>
          <Accordion>
            {content?.body?.map((childBlok) => (
              <Accordion.Item
                titleChild={childBlok?.title}
                key={childBlok._uid}
              >
                <SbEditable content={childBlok}>
                  <Text as="div" defaultColor="common">
                    {render(childBlok.desc)}
                  </Text>
                </SbEditable>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </SbEditable>
    </div>
  )
}

export default FAQ
